{
  "title": "Alertes",
  "subtitle": "Les problèmes que le système a repérés pour vous. La plupart des alertes se ferment d'elles-mêmes une fois le problème réglé.",
  "markAllRead": "Tout marquer comme lu",
  "markAllReadShort": "Tout lu",
  "markRead": "Marquer comme lu",
  "allMarked": "Toutes les alertes sont marquées comme lues.",
  "tabs": {
    "new": "Nouvelles",
    "read": "Lues",
    "resolved": "Résolues",
    "all": "Toutes"
  },
  "filters": {
    "type": "Type",
    "allTypes": "Tous les types",
    "location": "Emplacement"
  },
  "groups": {
    "new": "Nouvelles · {{count}}",
    "earlier": "Plus tôt",
    "seeAll": "Voir toutes les alertes"
  },
  "state": {
    "new": "Nouvelle",
    "read": "Lue",
    "resolved": "Résolue"
  },
  "inTotal": "Tous les emplacements",
  "loadMore": "Afficher plus",
  "empty": {
    "new": "Vous êtes à jour",
    "read": "Aucune alerte lue encore ouverte",
    "resolved": "Aucune alerte résolue pour l'instant",
    "all": "Aucune alerte pour l'instant",
    "text": "Les alertes apparaissent ici quand un stock devient bas, tombe à zéro ou sous zéro, qu'un transfert est en retard ou qu'un inventaire s'écarte trop."
  },
  "types": {
    "negative_stock": "Stock négatif",
    "large_adjustment": "Gros ajustement",
    "low_stock": "Stock bas",
    "transfer_delayed": "Transfert en retard",
    "out_of_stock": "Rupture",
    "count_variance": "Écart d'inventaire",
    "overstock": "Surstock",
    "job_failed": "Import ou sauvegarde en échec",
    "order_to_prepare": "Commande à préparer",
    "cod_overdue": "Contre-remboursement non réglé",
    "shift_open_late": "Service encore ouvert",
    "cash_variance": "Écart de caisse"
  },
  "short": {
    "negative_stock": "Négatif",
    "large_adjustment": "Validation",
    "low_stock": "Bas",
    "transfer_delayed": "En retard",
    "out_of_stock": "Rupture",
    "count_variance": "Écart",
    "overstock": "Surstock",
    "job_failed": "Échec",
    "order_to_prepare": "Commande",
    "cod_overdue": "CR",
    "shift_open_late": "Ouvert",
    "cash_variance": "Écart"
  },
  "text": {
    "negative_stock": {
      "title": "{{product}} est à {{quantity}}",
      "confirmed": "{{person}} l'a confirmé.",
      "detail": "Comptez le rayon ou saisissez la réception manquante pour revenir à zéro ou plus."
    },
    "large_adjustment": {
      "title": "{{number}} attend la validation d'un responsable",
      "detail": "Valeur {{value}} TND, au-dessus du seuil de validation de {{limit}} TND.",
      "detailBy": "Soumis par {{person}}. Valeur {{value}} TND, au-dessus du seuil de validation de {{limit}} TND."
    },
    "low_stock": {
      "title": "{{product}} est bientôt épuisé",
      "detail": "Il reste {{quantity}}. Le minimum pour cet emplacement est {{min}}.",
      "detailTotal": "Il reste {{quantity}} au total. Le minimum est {{min}}."
    },
    "transfer_delayed": {
      "title_one": "{{number}} n'est pas reçu en entier après {{count}} jour",
      "title_other": "{{number}} n'est pas reçu en entier après {{count}} jours",
      "detail_one": "Envoyé le {{date}}. Un transfert doit être reçu sous {{count}} jour.",
      "detail_other": "Envoyé le {{date}}. Un transfert doit être reçu sous {{count}} jours."
    },
    "out_of_stock": {
      "title": "{{product}} est en rupture",
      "detail": "Plus rien à {{place}}. {{elsewhere}} ailleurs.",
      "detailNowhere": "Plus rien à {{place}}, ni ailleurs."
    },
    "count_variance": {
      "title": "L'inventaire {{number}} s'écarte de {{percent}} %",
      "detail_one": "Le seuil est de {{limit}} %. {{count}} ligne avec écart, {{value}} TND au total.",
      "detail_other": "Le seuil est de {{limit}} %. {{count}} lignes avec écart, {{value}} TND au total."
    },
    "overstock": {
      "title": "{{product}} dépasse son maximum",
      "detail": "{{quantity}} en stock. Le maximum pour cet emplacement est {{max}}.",
      "detailTotal": "{{quantity}} en stock. Le maximum est {{max}}."
    },
    "job_failed": {
      "backup": "La sauvegarde a échoué",
      "import": "Un import a échoué",
      "detail": "Elle se ferme d'elle-même après la prochaine réussite."
    },
    "order_to_prepare": {
      "title": "Commande {{number}} à préparer",
      "detail_one": "{{count}} ligne, en attente sur ce site. Ouvrez-la pour commencer.",
      "detail_other": "{{count}} lignes, en attente sur ce site. Ouvrez-la pour commencer."
    },
    "cod_overdue": {
      "title": "Commande {{number}} : encaissement du livreur attendu",
      "detail_one": "Livrée il y a {{count}} jour, {{due}} TND attendus. Enregistrez le règlement du livreur.",
      "detail_other": "Livrée il y a {{count}} jours, {{due}} TND attendus. Enregistrez le règlement du livreur."
    },
    "shift_open_late": {
      "title": "{{register}} : service encore ouvert",
      "detail": "Le service de {{cashier}} est ouvert après l’heure de fermeture ({{time}}). Comptez la caisse et fermez-le."
    },
    "cash_variance": {
      "title": "{{register}} : écart de {{variance}} TND à approuver",
      "detail": "{{cashier}} a compté {{counted}} TND, {{expected}} TND attendus. Un responsable l’approuve pour fermer le service."
    }
  },
  "resolution": {
    "cleared": "Fermée automatiquement le {{date}}",
    "clearedBy": "Fermée automatiquement à la validation de {{reference}}",
    "read": "Fermée quand {{person}} l'a lue, {{date}}",
    "decided": "Fermée quand {{reference}} a été traité, {{date}}",
    "next_success": "Fermée automatiquement après la réussite suivante, {{date}}"
  },
  "actions": {
    "openProduct": "Ouvrir le produit",
    "review": "Examiner",
    "receive": "Réceptionner",
    "openTransfer": "Ouvrir le transfert",
    "transfer": "Transférer",
    "reviewCount": "Examiner l'inventaire",
    "openDataTools": "Ouvrir les outils de données",
    "openOrder": "Ouvrir la commande",
    "settleCod": "Enregistrer le règlement",
    "openShift": "Ouvrir le service"
  },
  "how": {
    "title": "Comment vous êtes prévenu",
    "bell": "Dans l'application (cloche)",
    "alwaysOn": "Toujours actif",
    "email": "E-mail pour chaque alerte",
    "digest": "Résumé quotidien par e-mail",
    "locations": "Emplacements suivis",
    "all": "Tous",
    "on": "Activé",
    "off": "Désactivé",
    "noEmail": "Vous n'avez pas encore d'adresse e-mail : un administrateur peut l'ajouter à votre compte.",
    "change": "Modifier les réglages d'alerte"
  },
  "meaning": {
    "title": "Ce que veut dire chaque alerte",
    "low_stock": "La quantité est au minimum ou en dessous, au total ou dans un emplacement.",
    "out_of_stock": "La quantité est exactement zéro.",
    "negative_stock": "La quantité est passée sous zéro après confirmation.",
    "overstock": "La quantité dépasse le maximum.",
    "transfer_delayed_one": "Envoyé mais pas reçu après {{count}} jour.",
    "transfer_delayed_other": "Envoyé mais pas reçu après {{count}} jours.",
    "large_adjustment": "Une correction vaut plus que le seuil de validation ({{limit}} TND).",
    "count_variance": "Un inventaire s'écarte de plus de {{percent}} % de la valeur attendue.",
    "job_failed": "Une tâche automatique n'a pas abouti. Administrateurs uniquement.",
    "order_to_prepare": "Une commande a été confirmée sur votre site : son stock est réservé et attend d’être préparé.",
    "cod_overdue": "Une commande en contre-remboursement a été livrée et le livreur n’a pas versé l’argent dans le délai fixé en Configuration.",
    "shift_open_late": "Un service est encore ouvert après l’heure de fermeture fixée en Configuration : son tiroir n’a pas été compté.",
    "cash_variance": "Un comptage de fermeture diffère des espèces attendues de plus que la limite : un responsable l’approuve avant le rapport Z."
  },
  "bell": {
    "title": "Notifications",
    "unread_one": "{{count}} nouvelle alerte",
    "unread_other": "{{count}} nouvelles alertes",
    "empty": "Vous êtes à jour",
    "emptyText": "Rien de nouveau depuis votre dernière visite.",
    "seeAll": "Voir toutes les alertes"
  }
}
